import axios from 'axios';
import apiUrl from '../constants';

export async function checkForAssignee(shippingid, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'disputeAssignee',
        data: {
            "shippingid" : shippingid
        },
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}


export async function assignDispute(data, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'disputeAssignMe',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}
export async function assignUserList(data, token){
  return axios({
     method: 'post',
     url: apiUrl.api_url + 'assingeeList',
     data: data,
     headers: {
       'Authorization': 'Bearer ' + token
     }
   });
}

export async function bulkDisputeAccept(data, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'acceptBulkDispute',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}





// WEBPACK FOOTER //
// ./src/services/disputeAssigneeCheck.js